<template>
  <div>
    <div
      class="notifications__head d-flex justify-content-between align-items-center p-2">
      <User
        :user="notification.pathActivity.user"
        :group="notification.createdByGroup" />
    </div>
    <div
      class="p-2">
      <div class="d-flex align-items-center py-1">
        <span
          class="material-icons text--grey05">
          edit_document
        </span>

        <p class="font-weight-bold">
          マイデータ
        </p>
      </div>
      <notification-card-path-activity-panel
        :activity="notification.pathActivity"
        @click-active="onClickActivePart" />
    </div>
  </div>
</template>

<script>
import NotificationCardPathActivityPanel from '@/components/view/NotificationCardPathActivityPanel.vue'
import User from '@/components/parts/User.vue'

export default {
  components: {
    NotificationCardPathActivityPanel,
    User,
  },
  props: {
    notification: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      checked: false,
      isProtecting: false
    }
  },
  methods: {
    async onClickActivePart() {
      this.$emit('click-notification', this.notification.id)
    },
    onCheckRead() {
      this.checked = !this.checked
      this.$emit('check-read', this.notification.id)
    },
  }
}
</script>

<style lang="scss" scoped>
.flag-icon {
  height: 18px;
  width: auto;
}

.notifications-heading-mark {
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background: $grey16;
  &--marked {
    background: $pink;
  }
}

.notifications{
  &__icon{
    display: inline-block;
    vertical-align: middle;
  }
  &__item{
    border: solid 1px $grey10;
    border-radius: 8px;
    background-color: $white;
  }
  &__heading{
    font-size: $fs-nm;
    font-weight: bold;
    position: relative;
  }
  &__box{
    text-align: right;
  }
  &__count{
    font-size: $fs-m;
    color: $l-blue;
    font-weight: bold;
  }
  &__date{
    font-size: $fs-s;
  }
  &__check {
    box-sizing: border-box;
    cursor: pointer;
    display: inline-block;
    position: relative;
    width: auto;
    &:before {
      background: #fff;
      border: 1px solid $grey05;
      content: '';
      display: block;
      height: 26px;
      margin-top: -10px;
      position: absolute;
      top: 50%;
      width: 26px;
      border-radius: 4px;
      right: 0;
    }
    &:after {
      border-right: 4px solid $l-blue;
      border-bottom: 4px solid $l-blue;
      content: '';
      display: block;
      height: 16px;
      margin-top: -7px;
      opacity: 0;
      position: absolute;
      top: 50%;
      transform: rotate(45deg);
      width: 10px;
      border-radius: 2px;
      right: 7px;
    }
  }
}

.notifications-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  &__btn {
    padding: 16px 8px;
  }
}

.comment{
  &__img{
    width: 30px;
    height: 30px;
    object-fit: cover;
  }
  &__name{
    font-weight: bold;
    font-size: $fs-m;
  }
  &__date{
    font-size: $fs-m;
  }
  &__body{
    white-space:pre-wrap;
    word-wrap:break-word;
    color: $grey04;
  }
}

</style>